'use client'

import Image from 'next/image'
import Link from 'next/link'
import { getMediaUrl } from 'src/_helpers/client/getMediaUrl'
import { getLocalizedThumb } from 'src/_helpers/getLocalizedThumb'
import { getSustainableDevelopmentGoalTitle } from 'src/_helpers/sustainableDevelopmentGoalTitle'
import LINKS from 'src/_helpers/links'
import Typography from 'src/components/design-system/Typography'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'

// Lista publikacji celu żyje na portalu głównym - na domenie czasopisma link musi być absolutny.
function getGoalHref(goal, locale) {
  const slug = goal?.translations?.[locale]?.slug
  const pattern = LINKS.SUSTAINABLE_DEVELOPMENT_GOALS.DETAIL[locale]

  if (!slug || !pattern) return null

  const href = pattern.replace(':slug', slug)
  const mainUrl = String(process.env.NEXT_PUBLIC_MAIN_URL || '').replace(/\/$/, '')

  return mainUrl ? `${mainUrl}${href}` : href
}

export default function SustainableDevelopmentGoals({ block, locale, variant }) {
  const translate = useTranslateEntry()
  // Nazwa bloku jest stała, tytuł zapisany w bloku pomijamy.
  const title = translate('T_BLOCK_SUSTAINABLE_DEVELOPMENT_GOALS_TITLE')
  const items = Array.isArray(block?.items) ? block.items : []
  if (!items.length) return null
  return (
    <section
      className={`flex flex-col gap-y-24 py-40 d:py-56 ${variant === 'monograph' ? 'd:px-40 px-16' : 'max-w-[894px]'} ${block.type.value}`}
      id={`${block.uuid}`}
    >
      {title && (
        <Typography variant="h2-bold" component="h2" color="text-basic-black">
          {title}
        </Typography>
      )}
      <ul className="m-0 flex list-none flex-wrap gap-16 p-0">
        {items.map((goal, i) => {
          const goalTitle = getSustainableDevelopmentGoalTitle(goal, locale)
          const goalHref = getGoalHref(goal, locale)
          const thumb = getLocalizedThumb(goal, 'cropped', locale)
          const thumbUrl = thumb ? getMediaUrl(thumb.url, thumb.version) : null

          if (!thumbUrl) return null

          const image = (
            <Image
              className="size-[164px] object-cover"
              src={thumbUrl}
              alt={goalTitle}
              width={thumb.width}
              height={thumb.height}
            />
          )

          return (
            <li key={goal?.uuid || i}>
              {goalHref ? (
                <Link
                  href={goalHref}
                  title={goalTitle}
                  className="block transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dark-blue-dark-blue2"
                >
                  {image}
                </Link>
              ) : (
                image
              )}
            </li>
          )
        })}
      </ul>
    </section>
  )
}
